import imageOnboarding3 from '../../assets/image-onboarding-3.webp';
import { ProgressIndicators } from '../progress-indicators';
import { OnboardingContinueButton } from '../onboarding-continue-button';
import { OnboardingScreen } from '../onboarding-layout';

interface Step4Props {
  onContinue: () => void;
}

export function OnboardingStep4({ onContinue }: Step4Props) {
  return (
    <OnboardingScreen
      slot="onboarding-step-4"
      header={
        <div className="flex w-full flex-col items-center gap-3">
          <ProgressIndicators currentStep={3} />

          <div className="w-full text-center">
            <h1 className="font-display text-[28px] font-bold leading-9 text-mf-neutral-900">
              Companies get fined. That money&apos;s meant for you.
            </h1>
            <p className="mt-2 text-base leading-5 text-mf-neutral-600">
              We&apos;re not a law firm — just help you collect what courts already say you&apos;re owed
            </p>
          </div>
        </div>
      }
      footer={<OnboardingContinueButton onClick={onContinue} />}
    >
      <div className="flex min-h-0 w-full flex-1 flex-col justify-center">
        <div className="mx-auto flex min-h-0 w-full max-w-[384px] flex-1 flex-col justify-center max-h-[320px]">
          <img
            src={imageOnboarding3}
            alt=""
            className="h-full min-h-0 w-full object-contain object-bottom"
          />
        </div>
      </div>
    </OnboardingScreen>
  );
}
